import styled from "styled-components";

import { adminRoutePaths } from "@pages/AdminDashboard/adminRoutes";
import { useIsPhoneLayout } from "@pages/AdminDashboard/theme/AdminLayout";
import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { ButtonLink } from "@pages/AdminDashboard/ui/Button";

const [, spaceSm] = adminTokens.spacing;
const smallButtonHeight = 30;

// On a phone the two Buttons share the card's width equally (FIND-R22).
const OpenInRow = styled.div<{ $isPhone: boolean }>`
  display: ${({ $isPhone }) => ($isPhone ? "flex" : "inline-flex")};
  gap: ${spaceSm - 2}px;
  min-height: ${smallButtonHeight}px;

  ${({ $isPhone }) => $isPhone && "& > * { flex: 1; }"}
`;

const openInAddress = (path: string, caseId: string | null | undefined) =>
  `${path}?case=${encodeURIComponent(caseId ?? "")}`;

interface OpenInButtonsProps {
  caseId: string | null | undefined;
  // What the Buttons act on, added to their names, such as an Order's ID (ACCT-R7).
  subject?: string;
}

// The secondary Buttons "Redo" and "Ship" that open a Case on those screens (CVIEW-R7, FIND-R22).
export const OpenInButtons = ({ caseId, subject }: OpenInButtonsProps) => {
  const isPhone = useIsPhoneLayout();

  return (
    <OpenInRow $isPhone={isPhone}>
      <ButtonLink
        look="secondary"
        to={openInAddress(adminRoutePaths.redo, caseId)}
        accessibleName={subject && `Redo ${subject}`}
      >
        Redo
      </ButtonLink>
      <ButtonLink
        look="secondary"
        to={openInAddress(adminRoutePaths.ship, caseId)}
        accessibleName={subject && `Ship ${subject}`}
      >
        Ship
      </ButtonLink>
    </OpenInRow>
  );
};
